import React from 'react'
import rehypeReact from 'rehype-react'
import SampleCode, { Container } from '../components/SampleCode'
import Loader from '../components/SampleCode/Loader'
import Row from '../components/Row'
import Alert from '../components/Alert'
import Table from '../components/Table'
import NumberedListCircle from '../components/NumberedListCircle'
import Tab from '../components/Tab'
import TabDescription from '../components/Tab/TabDescription'
import TabItem from '../components/TabItem'
import TableParam from '../components/TableParam'
import Link from '../components/Link'
import ChangelogLink from '../components/ChangelogLink'
import Parameter from '../components/Parameter'
import Sandbox from '../components/Sandbox'
import Collapse from '../components/Collapse'
import VersionSwapper from '../components/VersionSwapper'
import UseCasesNumberedList from '../components/UseCasesNumberedList'
import Video from '../components/Video'

export const renderAst = new rehypeReact({
  createElement: React.createElement,
  components: {
    row: Row,
    collapse: Collapse,
    alert: Alert,
    a: Link,
    parameter: Parameter,
    'sample-code': SampleCode,
    'sample-code-container': Container,
    'sample-code-loader': Loader,
    sandbox: Sandbox,
    table: Table,
    'numbered-list-circle': NumberedListCircle,
    tab: Tab,
    'tab-description': TabDescription,
    'tab-item': TabItem,
    'table-param': TableParam,
    'changelog-link': ChangelogLink,
    'version-swapper': VersionSwapper,
    'use-cases-numbered-list': UseCasesNumberedList,
    video: Video,
  },
}).Compiler
